const arePropsEqual = <T extends object>(
  prevProps: T,
  nextProps: T,
  excludeKeys: Array<keyof T> = []
) => {
  const keysPrev = (Object.keys(prevProps) as Array<keyof T>).filter(
    (key) => !excludeKeys.includes(key)
  );
  const keysNext = (Object.keys(nextProps) as Array<keyof T>).filter(
    (key) => !excludeKeys.includes(key)
  );

  if (keysPrev.length !== keysNext.length) {
    return false;
  }

  for (let i = 0; i < keysPrev.length; i++) {
    const currentKey = keysPrev[i];
    // @ts-ignore
    if (!Object.is(prevProps[currentKey], nextProps[currentKey])) {
      // console.debug(
      //   "these props are not the same",
      //   currentKey,
      //   // @ts-ignore
      //   prevProps[currentKey],
      //   // @ts-ignore
      //   nextProps[currentKey]
      // );
      return false;
    }
  }

  return true;
};

export default arePropsEqual;
